import React from "react";

// NovalynxTech brand logo — uses the user-provided PNG mark from /brand/logo-mark.png
// (a gold "N" with subtle diagonal accent). Falls back to a colored box if the image
// fails to load. All sizing/spacing is preserved from the previous SVG version so no
// callers need to change.

export function LogoMark({ size = 32, withGlow = true }) {
  const px = typeof size === "number" ? `${size}px` : size;
  return (
    <span
      className="inline-flex items-center justify-center rounded-xl bg-black shrink-0 overflow-hidden"
      style={{ width: px, height: px, boxShadow: withGlow ? "0 6px 20px -6px hsl(var(--primary) / 0.55)" : "none" }}
      aria-hidden="true"
      data-testid="logo-mark"
    >
      <img
        src="/brand/logo-mark.png"
        alt=""
        className="w-full h-full object-contain"
        draggable="false"
      />
    </span>
  );
}

export function LogoWordmark({ className = "" }) {
  return (
    <span className={`font-display font-bold tracking-tight ${className}`} data-testid="logo-wordmark">
      Novalynx<span className="text-primary">Tech</span>
    </span>
  );
}

export default function Logo({ size = 32, className = "text-xl" }) {
  return (
    <span className="flex items-center gap-2" data-testid="brand-logo">
      <LogoMark size={size} />
      <LogoWordmark className={className} />
    </span>
  );
}
